(function () {
  const overlay = document.getElementById("bmd-gummy-canvas");

  if (!overlay) return;

  let animationRunning = false;
  let initialized = false;

  function initAnimation() {
    if (initialized) return;

    initialized = true;

     var SRCS=[
    'https://cdn.shopify.com/s/files/1/0657/7913/8630/files/image_4.png?v=1781768266','https://cdn.shopify.com/s/files/1/0657/7913/8630/files/image_3.png?v=1781768266','https://cdn.shopify.com/s/files/1/0657/7913/8630/files/image_1.png?v=1781768265','https://cdn.shopify.com/s/files/1/0657/7913/8630/files/image_5.png?v=1781768264','https://cdn.shopify.com/s/files/1/0657/7913/8630/files/image_2.png?v=1781768265'
  ];
  var IMGS=[],loaded=0;
  SRCS.forEach(function(src){
    var img=new Image();
    img.onload=function(){loaded++;if(loaded===SRCS.length)init();};
    img.src=src;IMGS.push(img);
  });
  function init(){document.dispatchEvent(new Event("bmd:gummiesReady"));
    var canvas=document.getElementById('bmd-gummy-canvas');
    var container=canvas.parentElement;
    function size(){canvas.width=window.innerWidth;canvas.height=window.innerHeight;}
    size();
    var W=canvas.width,H=canvas.height,ctx=canvas.getContext('2d');
    var engine=Matter.Engine.create({gravity:{x:0,y:1.9}});
    var world=engine.world;
    Matter.World.add(world,[
      Matter.Bodies.rectangle(W/2,H+40,W+400,80,{isStatic:true,friction:1.0,restitution:0}),
      Matter.Bodies.rectangle(-40,H/2,80,H*8,{isStatic:true,friction:1.0}),
      Matter.Bodies.rectangle(W+40,H/2,80,H*8,{isStatic:true,friction:1.0})
    ]);
    var GUMMY_R=W<768?34:50,BODY_R=GUMMY_R*0.92;
    var gummies=[],imgCounter=0;
    function makeGummy(x,y,vy){
      var body=Matter.Bodies.circle(x,y,BODY_R,{restitution:0.05,friction:0.4,frictionAir:0.012,density:0.005});
      Matter.Body.setAngle(body,Math.random()*Math.PI*2);
      Matter.Body.setVelocity(body,{x:(Math.random()-0.5)*1.2,y:vy||0});
      Matter.Body.setAngularVelocity(body,(Math.random()-0.5)*0.08);
      Matter.World.add(world,body);
      gummies.push({body:body,r:GUMMY_R,imgIdx:imgCounter%IMGS.length});
      imgCounter++;
    }
    var SPAWN_INTERVAL=45,SPAWN_BATCH=2,lastSpawn=0;
    var FILL_THRESHOLD=H*0.06;
    var bandCount=Math.max(6,Math.floor(W/(BODY_R*2.1))),bandW=W/bandCount;
    function dropIntoEmptyBands(){if(window.__bmdGummyAuto&&gummies.filter(function(g){return g.body.position.y<H+50;}).length>=Math.round(W/(BODY_R*2)*(W<768?1.5:2)))return;
      var bandTops=new Array(bandCount).fill(H);
      gummies.forEach(function(g){
        var p=g.body.position;if(p.x<0||p.x>W)return;
        var b=Math.min(bandCount-1,Math.max(0,Math.floor(p.x/bandW)));
        if(p.y<bandTops[b])bandTops[b]=p.y;
      });
      var emptyBands=[];
      for(var i=0;i<bandCount;i++){var TH=window.__bmdGummyAuto?H-(W<768?1.5:2)*BODY_R*2:FILL_THRESHOLD;if(bandTops[i]>TH)emptyBands.push(i);}
      if(emptyBands.length===0)return;
      for(var n=0;n<SPAWN_BATCH&&emptyBands.length>0;n++){
        var pick=Math.floor(Math.random()*emptyBands.length);
        var band=emptyBands[pick];emptyBands.splice(pick,1);
        var x=band*bandW+bandW*0.5+(Math.random()-0.5)*(bandW*0.4);
        makeGummy(x,-BODY_R-Math.random()*40,Math.random()*1.0);
      }
    }
    var mx=-9999,my=-9999;
    var REPEL_RADIUS=140,REPEL_FORCE=0.07,MAX_V=4.5;
    window.addEventListener('mousemove',function(e){
      var rect=canvas.getBoundingClientRect();
      mx=e.clientX-rect.left;my=e.clientY-rect.top;
    });
    Matter.Events.on(engine,'beforeUpdate',function(){
      gummies.forEach(function(g){
        var p=g.body.position,dx=p.x-mx,dy=p.y-my,d=Math.sqrt(dx*dx+dy*dy);
        if(d<REPEL_RADIUS&&d>0.5){
          var f=(1-d/REPEL_RADIUS)*(1-d/REPEL_RADIUS);
          var s=f*REPEL_FORCE*g.body.mass;
          Matter.Body.applyForce(g.body,p,{x:(dx/d)*s,y:(dy/d)*s*0.6});
        }
        var v=g.body.velocity,sp=Math.sqrt(v.x*v.x+v.y*v.y);
        if(d<REPEL_RADIUS*1.5&&sp>MAX_V){Matter.Body.setVelocity(g.body,{x:v.x*MAX_V/sp,y:v.y*MAX_V/sp});}
      });
    });
    Matter.Runner.run(Matter.Runner.create(),engine);
    function loop(ts){
      ctx.clearRect(0,0,W,H);
      if(ts-lastSpawn>SPAWN_INTERVAL){dropIntoEmptyBands();lastSpawn=ts;}
      if(gummies.length>700){
        gummies=gummies.filter(function(g){
          if(g.body.position.y>H+150){Matter.World.remove(world,g.body);return false;}
          return true;
        });
      }
      gummies.forEach(function(g){
        var pos=g.body.position;if(pos.y<-g.r*2)return;
        ctx.save();
        ctx.translate(pos.x,pos.y);ctx.rotate(g.body.angle);
        ctx.shadowColor='rgba(140,60,0,0.30)';ctx.shadowBlur=12;
        ctx.shadowOffsetX=3;ctx.shadowOffsetY=4;
        ctx.drawImage(IMGS[g.imgIdx],-g.r,-g.r,g.r*2,g.r*2);
        ctx.restore();
      });
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
    window.addEventListener('resize',size);
  }
  }

  function startAnimation() {
    initAnimation();

    animationRunning = true;
    overlay.style.transition = 'opacity .8s ease'; overlay.style.opacity = '1'; overlay.style.display = 'block'
  }

  function stopAnimation() {
    animationRunning = false;
   overlay.style.display = 'none';
  }

  document.addEventListener("alia:popupView", function () { if (overlay.dataset.auto !== "1") startAnimation(); });
  document.addEventListener("alia:popupClose", function () { if (overlay.dataset.auto !== "1") stopAnimation(); });
  document.a// Homepage auto drop: a short pile of gummies (2-3 rows) plus a product card. Once per session. Click anywhere to dismiss.
  if (overlay.dataset.auto === "1") {
    var aliaOpen = false;
    var seen = false;
    try { seen = sessionStorage.getItem("bmdGummyShow") === "1"; } catch (e) {}
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!seen) {
      try { sessionStorage.setItem("bmdGummyShow", "1"); } catch (e) {}
      var d = overlay.dataset, card = null, done = false;
      var css = document.createElement("style");
      css.textContent = "#bmd-gc{position:fixed;left:84px;bottom:calc(24px + env(safe-area-inset-bottom,0px));z-index:9999;width:min(380px,calc(100vw - 32px));display:flex;gap:14px;align-items:center;padding:14px 16px 14px 14px;background:#fff;border-radius:18px;border:1.5px solid rgba(7,121,137,.45);box-shadow:0 0 0 4px rgba(7,121,137,.10),0 22px 48px -10px rgba(0,0,0,.45),0 6px 16px rgba(0,0,0,.14);font-family:inherit;color:#212021;opacity:0;transform:translateY(24px) scale(.96);transition:opacity .45s ease,transform .5s cubic-bezier(.2,.9,.25,1.2)}#bmd-gc.on{opacity:1;transform:none}#bmd-gc img{width:84px;height:84px;object-fit:contain;flex:0 0 84px;border-radius:12px;background:#fff4ec}#bmd-gc .t{display:flex;flex-direction:column;gap:4px;min-width:0}#bmd-gc .k{font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#f26b21}#bmd-gc .h{font-size:16px;font-weight:700;line-height:1.2}#bmd-gc .o{font-size:13px;line-height:1.35;color:#4a454a}#bmd-gc .o b{color:#212021}#bmd-gc sup{font-size:.65em;line-height:0}#bmd-gc .b{align-self:flex-start;margin-top:6px;display:inline-flex;align-items:center;height:38px;padding:0 20px;border-radius:19px;background:#077989;color:#fff;font-size:14px;font-weight:600;text-decoration:none;position:relative;overflow:hidden}#bmd-gc .b:hover{background:#05606c}#bmd-gc .b::after{content:'';position:absolute;top:0;bottom:0;left:-60%;width:40%;background:linear-gradient(100deg,transparent,rgba(255,255,255,.45),transparent);transform:skewX(-20deg);animation:bmdgcs 3.2s ease-in-out 1s infinite}@keyframes bmdgcs{0%{left:-60%}35%,100%{left:130%}}#bmd-gc .x{position:absolute;top:6px;right:8px;width:28px;height:28px;border:0;background:transparent;font-size:20px;line-height:1;color:#8a848a;cursor:pointer}@media (max-width:767px){#bmd-gc{right:auto;left:16px;bottom:calc(84px + env(safe-area-inset-bottom,0px))}}@media (prefers-reduced-motion:reduce){#bmd-gc,#bmd-gc .b::after{transition:none;animation:none}}";
      document.head.appendChild(css);
      var dismiss = function () {
        if (done) return; done = true;
        if (card) { card.classList.remove("on"); setTimeout(function () { card && card.remove(); }, 500); }
        window.__bmdGummyAuto = false; overlay.style.opacity = "0"; setTimeout(function () { stopAnimation(); }, 600);
      };
      var showCard = function () {
        if (done || aliaOpen) return;
        card = document.createElement("div");
        card.id = "bmd-gc"; card.setAttribute("role", "dialog"); card.setAttribute("aria-label", "Happy Saffron Plus Gummies");
        card.innerHTML = '<button class="x" type="button" aria-label="Close">&times;</button>' + (d.img ? '<img src="' + d.img + '" alt="Happy Saffron Plus Gummies bottle" width="84" height="84">' : '') + '<div class="t"><span class="k">Viral on TikTok</span><span class="h">Happy Saffron Plus&reg; Gummies</span><span class="o">Mood, memory &amp; libido support in a sugar-free gummy.<sup>*</sup> <b>Save 10%</b> on the 2-pack, up to <b>25%</b> when you subscribe.<sup>**</sup></span><a class="b" href="' + (d.url || "/products/happy-saffron-plus-gummies") + '">Shop Gummies</a></div>';
        document.body.appendChild(card);
        requestAnimationFrame(function () { requestAnimationFrame(function () { card.classList.add("on"); }); });
        card.querySelector(".x").addEventListener("click", dismiss);
      };
      window.__bmdGummyTest = function () { window.__bmdGummyAuto = true; startAnimation(); };
      var run = function () {
        if (typeof Matter === "undefined") { return setTimeout(run, 200); }
        if (aliaOpen) return;
        if (reduce) { showCard(); return; }
        window.__bmdGummyAuto = true;
        startAnimation();
      };
      document.addEventListener("bmd:gummiesReady", function () { setTimeout(showCard, 1400); });
      if (document.readyState !== "loading") setTimeout(run, 600); else document.addEventListener("DOMContentLoaded", function () { setTimeout(run, 600); });
    }
  }
})();
